import { Input } from "design-react-kit";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation, useHistory } from "react-router-dom";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import UploadFile from "../../Components/UploadFile";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function NewAnnouncement(props) {
  const apiToken = useContext(TokenContext);
  const d = new Date();
  const [selectedService, setSelectedService] = useState(false);
  const [servicesList, setServicesList] = useState();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [serviceName, setServiceName] = useState();
  const [filterRange, setFilterRange] = useState("");
  const [validation, setValidation] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [ranges, setRanges] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("Tutti");
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState(false);

  let query = useQuery();

  const [data, setData] = useState({
    serviceId: query.get("id"),
    name: query.get("name") && query.get("name") + " - " + d.getFullYear(),
    cost: null,
    bandsId: null,
  });

  useEffect(() => {
    if (apiToken) {
      setLoading(false);

      if (query.get("id") && query.get("name")) {
        setServiceId(query.get("id"));
        setServiceName(query.get("name"));
        setSelectedService(true);
      } else {
        Repo.getServices(apiToken)
          .then((response) => {
            setServicesList(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
            setLoading(true);
          });
      }
      Repo.getRangesList(apiToken)
        .then((response) => {
          setRanges(
            response.data.map((x) => ({
              ...x,
              selected: false,
            })),
          );
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getListaServizi(apiToken)
        .then((response) => {
          setServizi(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const toggleRange = (id) => {
    setRanges((prev) =>
      prev.map((x) => (x.id === id ? { ...x, selected: !x.selected } : x)),
    );
  };

  const getGroupName = (name) => {
    return name
      .replace(/\s+MINORE.*$/i, "")
      .replace(/\s+MAGGIORE.*$/i, "")
      .replace(/\s+FINO(\s+A)?\s+.*$/i, "")
      .trim();
  };

  const gruppi = [
    "Tutti",
    ...new Set(ranges.map((x) => getGroupName(x.name))),
  ].sort();

  const filteredRanges = ranges.filter((x) => {
    const okGruppo =
      selectedGroup === "Tutti" || getGroupName(x.name) === selectedGroup;

    const okNome = x.name.toLowerCase().includes(filterRange.toLowerCase());

    return okGruppo && okNome;
  });

  const checkSession = () => {
    setValidation(true);

    let passedValidation = true;

    const temp = {
      ...data,
      bandsId: ranges.filter((x) => x.selected).map((x) => x.id),
    };

    if (!temp.serviceId) passedValidation = false;
    if (!temp.name) passedValidation = false;
    if (!temp.codAccertamento) passedValidation = false;
    if (!temp.codCapitolo) passedValidation = false;
    if (!temp.nomeMyPay) passedValidation = false;

    if (passedValidation) {
      setData(temp);
      toggleModal(true);
    }
  };

  const postInsertSession = () => {
    const dto = {
      ...data,
      bandsId: ranges.filter((x) => x.selected).map((x) => x.id),
    };

    Repo.postInsertSession(apiToken, JSON.stringify(dto))
      .then((response) => {
        if (response.status == 200) {
          window.location.href =
            props.subfolder +
            "/lista_bandi?id=" +
            serviceId +
            "&name" +
            serviceName;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const transferBlock = () => {
    return (
      <>
        <div className="row mt-4 mb-3">
          <div className="col-lg-4">
            <Select
              options={gruppi.map((x) => ({
                value: x,
                label: x,
              }))}
              value={{
                value: selectedGroup,
                label: selectedGroup,
              }}
              onChange={(e) => setSelectedGroup(e.value)}
              placeholder="Servizio"
            />
          </div>

          <div className="col-lg-4">
            <Input
              id="filterRange"
              label="Filtra fasce ISEE"
              type="text"
              value={filterRange || ""}
              placeholder="Cerca per nome..."
              onChange={(e) => setFilterRange(e.target.value)}
            />
          </div>

          <div className="col-lg-4 text-right align-self-end">
            <strong>
              {ranges.filter((x) => x.selected).length} fasce selezionate
            </strong>
          </div>
        </div>

        <div className="card card-bg no-after roundedCustom">
          <div className="card-body p-0">
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  <th style={{ width: "60px" }}></th>
                  <th>Fascia ISEE</th>
                  <th>Contributo</th>
                </tr>
              </thead>

              <tbody>
                {filteredRanges.length > 0 ? (
                  filteredRanges.map((x) => (
                    <tr
                      key={x.id}
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleRange(x.id)}
                    >
                      <td className="align-middle text-center">
                        <input
                          type="checkbox"
                          checked={!!x.selected}
                          onChange={() => toggleRange(x.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </td>

                      <td className="align-middle">
                        <strong>
                          {Number(x.min).toLocaleString("it-IT")} €{" - "}
                          {Number(x.max).toLocaleString("it-IT")} €
                        </strong>
                      </td>

                      <td className="align-middle">
                        {x.percent > 0 ? (
                          <>
                            <strong>{x.percent}%</strong>
                            <br />
                            <small className="text-muted">
                              Max {Number(x.fixedCost).toLocaleString("it-IT")}{" "}
                              €
                            </small>
                          </>
                        ) : (
                          <strong>
                            {Number(x.fixedCost).toLocaleString("it-IT")} €
                          </strong>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4">
                      Nessuna fascia trovata
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <h1>Inserimento bando</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Inserimento di un nuovo bando per il servizio o duplica da bando
          precedente
        </p>
      </div>

      <div className="row mt-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-secondary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => history.goBack()}
            title="Torna indietro"
          >
            Indietro
          </button>
        </div>
      </div>

      <div className="row">
        <div className="bootstrap-select-wrapper col-lg-6">
          <Select
            aria-label="Servizio"
            clearText="Annulla"
            defaultMenuIsOpen={false}
            required
            icon={false}
            name="servizio"
            id="servizio"
            options={servizi}
            onChange={(e) => {
              setServizioTemp(e ? e.label : null);
              setData({ ...data, serviceId: e.value });
              setServiceName();
            }}
            isClearable
            isSearchable
            value={data.serviceId}
            placeholder={
              servizioTemp
                ? servizioTemp
                : serviceName
                  ? serviceName
                  : "Seleziona servizio*"
            }
          />
          {validation && !data.serviceId ? (
            <small id="errorSelect" className="form-text text-danger">
              Il campo non può essere vuoto!
            </small>
          ) : (
            <></>
          )}
        </div>
        <div className="col-lg-6">
          <Input
            id="title"
            label="Titolo*"
            type="text"
            name="title"
            value={data && data.name ? data.name : ""}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            {...(validation &&
              !data.name && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        {/* <div className="col-lg-4">
                  <Input
                    id="cost"
                    label="Costo prestazione"
                    type="number"
                    name="cost"
                    onChange={(e) => setData({ ...data, cost: e.target.value })}
                    infoText="Inserire il valore solo se non sono presenti fasce ISEE"
                  />
                </div> */}
      </div>
      <div className="row mt-4 mb-2">
        <div className="col-lg-4">
          <Input
            id="nomeMyPay"
            label="Nome Servizio MyPay*"
            type="text"
            name="nomeMyPay"
            value={data.nomeMyPay || data.nomeMyPay || ""}
            onChange={(e) => setData({ ...data, nomeMyPay: e.target.value })}
            {...(validation &&
              !data.nomeMyPay && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="codAccertamento"
            label="Codice Accertamento*"
            type="text"
            name="codAccertamento"
            value={data.codAccertamento || data.codAccertamento || ""}
            onChange={(e) =>
              setData({
                ...data,
                codAccertamento: e.target.value,
              })
            }
            {...(validation &&
              !data.codAccertamento && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="codCapitolo"
            label="Codice Capitolo*"
            type="text"
            name="codCapitolo"
            value={data.codCapitolo || data.codCapitolo || ""}
            onChange={(e) => setData({ ...data, codCapitolo: e.target.value })}
            {...(validation &&
              !data.codCapitolo && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
      </div>
      <h6>Fasce ISEE:</h6>
      {transferBlock()}

      <div className="row mt-3">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => checkSession()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuovo bando"
        body="Confermi di voler inserire un nuovo bando?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => postInsertSession()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default NewAnnouncement;
